export enum Chain {
  'polygon' = 137,
  'mumbai' = 80001,
  'bnb' = 56,
  'bnb-testnet' = 97
}

export const address: {
  [key in Chain]: string
} = {
  // Polygon mainnet
  [Chain.polygon]: 'https://1rpc.io/matic',
  // Mumbai
  [Chain.mumbai]: 'https://rpc-mumbai.maticvigil.com',
  // BNB mainnet
  [Chain.bnb]: 'https://bsc-dataseed4.ninicoin.io',
  // BNB testnet
  [Chain['bnb-testnet']]: 'https://data-seed-prebsc-2-s3.binance.org:8545'
}

export const info: {
  [key in Chain]: {
    symbol: string
    decimal: number
  }
} = {
  [Chain.bnb]: {
    decimal: 18,
    symbol: 'BNB'
  },
  [Chain['bnb-testnet']]: {
    decimal: 18,
    symbol: 'BNB'
  },
  [Chain.mumbai]: {
    decimal: 18,
    symbol: 'MATIC'
  },
  [Chain.polygon]: {
    decimal: 18,
    symbol: 'MATIC'
  }
}
